import { createSlice } from '@reduxjs/toolkit';
import sustainabilityApi from '../apis/sustainability.api';
import type { QuestionAnswerDto } from '../../models/sustainability';

const initialState: {
	byProfileId: Record<number, Record<number, QuestionAnswerDto | null>>;
} = {
	byProfileId: {}
};

const certificateQuestionSlice = createSlice({
	name: 'certificateQuestion',
	initialState,
	reducers: {
		clearCertificateQuestion(state, action: { payload: { profileId: number; formId: number } }) {
			const { profileId, formId } = action.payload;
			if (state.byProfileId[profileId]) {
				delete state.byProfileId[profileId][formId];
			}
		},
		clearCertificateQuestionsByProfileId(state, action: { payload: { profileId: number } }) {
			const { profileId } = action.payload;
			delete state.byProfileId[profileId];
		}
	},
	extraReducers: (builder) => {
		builder.addMatcher(
			sustainabilityApi.endpoints.getCertificateQuestion.matchFulfilled,
			(state, action) => {
				const { profileId, formId } = action.meta.arg.originalArgs;
				state.byProfileId[profileId] = state.byProfileId[profileId] ?? {};
				state.byProfileId[profileId][formId] = action.payload ?? null;
			}
		);
	}
});

export const { clearCertificateQuestion, clearCertificateQuestionsByProfileId } =
	certificateQuestionSlice.actions;

export const selectCertificateQuestion = (
	state: {
		certificateQuestion: {
			byProfileId: Record<number, Record<number, QuestionAnswerDto | null>>;
		};
	},
	profileId: number,
	formId: number
): QuestionAnswerDto | null =>
	state.certificateQuestion?.byProfileId?.[profileId]?.[formId] ?? null;

export default certificateQuestionSlice.reducer;

